import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import { ActionItemPriorityEnum } from '@/types/schema';

import { useActionItemContext } from '../../context';
import { ActionPriorityProps } from '../../types';
import { isTaskEditable } from '../utils';
import ActionPrioritySelector from './ActionPrioritySelector';

const ActionPriority = ({ className, hideLabel = false }: ActionPriorityProps) => {
  const { t } = useTranslation();
  const {
    actionItem,
    actions,
    provider,
    isReadOnly,
    disableInteractiveTooltip = false,
  } = useActionItemContext();
  const priority = actionItem.priority || ActionItemPriorityEnum.NoPriority;

  const editable = !isReadOnly && isTaskEditable(provider) && Boolean(actions);

  const onChange = useCallback(
    (newPriority: ActionItemPriorityEnum) => {
      actions?.onPriorityChange(newPriority, actionItem.id);
    },
    [actions, actionItem.id],
  );

  return (
    <Stack alignItems="center" className={cn(className, 'w-full')} direction="row">
      <ActionPrioritySelector
        className={'px-8 h-32'}
        disableInteractiveTooltip={disableInteractiveTooltip}
        editable={editable}
        priority={priority}
        showLabel={!hideLabel}
        variant="sidebar"
        onChange={onChange}
      />
    </Stack>
  );
};

export default React.memo(ActionPriority);
